import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from "src/app/_utilities/subscription";

@Component({
  selector: "app-no-records-available",
  templateUrl: "./no-records-available.component.html",
  styleUrls: ["./no-records-available.component.scss"],
  standalone: false,
})
export class NoRecordsAvailableComponent
  extends SubscriptionUtil
  implements OnInit, OnChanges {
  translate: any;
  //a key for pass the object parent to child
  @Input() messageKey: string = "";
  @Input() message?: string = "";
  displayMessage: string = "";

  constructor(private languageTranslateService: LanguageTranslateService) {
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.message) {
      this.setDisplayMessage();
    }
  }
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.setDisplayMessage();
        }
      }),
    );
  }

  setDisplayMessage() {
    const allMessages: { [key: string]: string | undefined } = {
      setupApprovals:
        "No approval relationships created yet. Add one to see it here.",
      setupImportExport:
        "No import or export records available. Import or export data to see it here.",
      setupEmails: "No email templates available. Create one to see it here.",
      setupWorkflows: "No workflows available. Create one to see it here.",
      setupNotificationsEmail:
        "No email notifications available yet. Create one to see it here.",
      setupNotificationsInApp:
        "No in-app notifications available. Create one to see it here.",
      setupSkills: "No skills created yet. Create one to see it here.",
      setupTeams: "No teams created yet. Create one to see it here.",
      jobListInPlanner: this.message,
      jobListInPlannerInitial:
        this.translate?.general.buttons.select2.singular +
        " " +
        this.translate?.customer.label.singular +
        " " +
       this.translate?.planner.messages.or +
       " " +
        this.translate?.contracts.label.plural +
        " " +
       this.translate?.general.messages.toLower +
         " " +
       this.translate?.general.buttons.view.singular +
         " " +
        this.translate?.site.messages.scheduled +
        " " +
        this.translate?.setup.modules.types.fields.job.plural
        + " " +
        this.translate?.setup.modules.templates.messages.for 
        + " " +
        this.translate?.task.fields.today.singular,
    };

    const message = allMessages[this.messageKey];

    if (message) {
      this.displayMessage = message;
    } else {
      this.displayMessage =
        this.translate?.general.messages.noRecordsAvailable ??
        "No Records Available";
    }
  }

  push(obs: any) {
    super.push(obs);
  }
}
